export default __webpack_public_path__ + "static/media/shib-wei.4a0021bb.svg";